import { Flex } from "styled-system/jsx";
import { Button, ButtonProps } from "@ttc3k/trekker";
import { PropsWithChildren } from "react";

interface SignupLayoutProps extends PropsWithChildren {
  onNextClick: (() => Promise<void>) | (() => void) | null;
  buttonProps?: ButtonProps;
}

export const SignupLayout = ({
  onNextClick,
  buttonProps,
  children,
}: SignupLayoutProps) => (
  <Flex
    flexDir={"column"}
    gap={"400"}
    alignItems={"center"}
    w={{
      base: "full",
      md: "500px",
    }}
  >
    {children}
    <Button
      w={{ base: "full", md: "260px" }}
      size={"lg"}
      onClick={buttonProps.onClick ?? onNextClick}
      {...buttonProps}
    />
  </Flex>
);
